import React from 'react';
import styled, { css } from 'styled-components/macro';
import { MiniButton } from '@yme/atoms/mini-button';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { HeadingLevel4 } from '@yme/tokens/typography';
export const HeadingLevel4Styled = styled(HeadingLevel4) `
  text-align: initial;
  ${({ isMarginTop }) => isMarginTop && 'margin-top: 4px;'};
`;
export const NavigationStyled = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
  height: 64px;

  ${ADAPTIVE.minWidth.desktop} {
    height: 68px;
  }
`;
// TODO: (D.K.) Need use special component for this feature (for now it doesn't implement)
export const NavigationMiniButtonStyled = styled(MiniButton) `
  ${({ isLeftSide, isRightToLeft }) => isLeftSide
    ? css `
          padding: ${INDENT.none};

          ${ADAPTIVE.maxWidth.mobile} {
            ${() => (isRightToLeft ? `margin-left: ${INDENT.xs};` : `margin-right: ${INDENT.xs};`)};
          }
        `
    : `padding: ${INDENT.none};`}

  ${({ isAlignStart }) => isAlignStart && 'align-self: flex-start;'}
`;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const SVGFAQIconStyled = styled(({ isRightToLeft, ...rest }) => React.createElement(SVGIcon, { ...rest })) `
  display: inline-block;
  vertical-align: middle;
  margin: ${({ isRightToLeft }) => (isRightToLeft ? '0 0 0 8px' : '0 8px 0 0')};
`;
export const FAQContainerStyled = styled.span `
  white-space: nowrap;
  text-align: ${({ isRightToLeft }) => (isRightToLeft ? 'left' : 'right')};
`;
export const FAQTextStyled = styled.span `
  white-space: normal;
`;
